import get from 'lodash/get';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import compose from 'recompose/compose';
import withHandlers from 'recompose/withHandlers';
import {formDataManager} from 'hoc/formDataManager';
import AwardDaysModal from './AwardDaysModal';
import config from './awardDaysFormConfig';
import {submitAwardDaysAction, endAwardDaysAction} from '../../../actions';

const mapStateToProps = state => {
  const {awardingDays, awardDaysSubmitted, currentUserId, currentUser} = state.userManagement;
  return {
    userId: currentUserId,
    email: get(currentUser, 'email', null),
    modalOpen: awardingDays,
    awarding: awardDaysSubmitted
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({
  awardDays: submitAwardDaysAction,
  handleClose: endAwardDaysAction
}, dispatch);

const AwardDaysModalContainer = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    onSaveData: props => data => props.awardDays(Number(props.userId), Number(data.amount))
  }),
  formDataManager({amount: ''}, config)
)(AwardDaysModal);

export default AwardDaysModalContainer;



// WEBPACK FOOTER //
// ./public/pages/UserManagement/UserDetailPage/modals/AwardDaysModal/AwardDaysModalContainer.js